<template>
    <div>
        <check-list :listArray="listArray"></check-list>
    </div>
</template>
<script>
    import CheckList from './check/checkList.vue';

    export default {
        data () {
            return {
                listArray: [
                    {
                        icon:'far fa-check-circle',
                        title:'פיתוח Client מודרני',
                        text:'פיתוח rich client בטכנולוגיות החדשות בשוק. מומחים בפיתוח ב React, Vue ו Angular תוך שימוש בארכיטקטורת unidirectional data flow. קוד מקצועי, נקי ומסודר, מבוסס ES6 ועקרונות תכנות פונקציונליים וריאקטיביים במקסימום ביצועים ובחוויית משתמש יוצאת דופן. עובדים תמיד עם eslint.'},

                    {
                        icon:'far fa-check-circle',
                        title:'צוות מגוון ומקצועי',
                        text:'צוות הפיתוח המגוון הוא שמאפשר לנו להציע מגוון עבודות פיתוח ללא פשרות מקצועיות. כולנו יוצאי יחידות טכנולגויות יוקרתיות ובעלי ניסיון של שנים במגוון רחב של טכנולוגיות.'
                    },
                    {
                        icon: 'far fa-check-circle',
                        title:'מחיר הוגן',
                        text:'העסקה המשתלמת בשוק. בעבודה איתנו תקבלו צוות פיתוח חזק, מקצועי ומגוון במחיר של פרילנסר.'},
                    {
                        icon:'far fa-check-circle',
                        title:'Git',
                        text:'עבודה עם כליי version control מתקדמים בסטנדרט מחמיר, מקצועי וללא פשרות.'},
                    {
                        icon:'far fa-check-circle',
                        title:'פיתוח Full Stack',
                        text:'ניסיון עשיר במגוון רחב של שפות, פריימוורקים, design patterns ומסדי נתונים. עובדים RestAPI, משתמשים ב GraphQL ושולטים בסביבות SQL ו NoSQL.'},
                    {
                        icon:'far fa-check-circle',
                        title:'עבודה ב remote',
                        text:'מומחים בעבודת שלט רחוק ולעולם לא דורשים משאבים.'
                    },
                ],
            }
        },
        components: {
            'check-list': CheckList,
        }
    }
</script>
